
import React from 'react';
import MenuBar from '@/components/MenuBar';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-6 pb-12">
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-foreground">{t('navigation.about')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-foreground">
              Briefr ble grunnlagt i 2025 og eies og driftes av Briefr Media AS.
            </p>
            
            <p className="text-foreground">
              Anno 2025 befinner medielandskapet seg stadig i en tilstand av omveltning, en fragmentert arena der kampen om oppmerksomhet, tillit og selve definisjonen av sannhet utkjempes i stadig nye arenaer og formater. Tiden da tradisjonelle mediehus var samfunnets ubestridte portvoktere for informasjon er i endring. Deres rolle og legitimitet er utfordret fra alle kanter: av sosiale mediers algoritmiske makt, av en eksplosjon i AI-generert innhold, og av politiske strømninger som aktivt undergraver felles virkelighetsoppfatninger. Samtidig utfordres medienes driftsmodeller i slag med kampen om oppmersomhet og tillit fra yngre generasjoner som i større grad enn tidligere mottar nyheter fra alternative kilder fra fjern og nær.
            </p>
            
            <p className="text-foreground">
              I denne tidsperioden for transformasjon og tilpasning er det Briefr Medias formål å bidra til å opprettholde og styrke vilkårene for sannhet, kunnskap og tillit i samfunnet. Vi ønsker å styrke en politisk kultur tuftet på sannhet og kunnskap som utgangspunkt, kompromiss og samarbeid som metoder til å oppnå vårt demokratiske felleskaps interesser.
            </p>
            
            <p className="text-foreground">
              Vi mener medias samfunnskritiske rolle kan utspilles i nye format og tilpassede driftsmodeller. Briefr Media vil sette mennesker og kunnskap i sentrum for vår formidling av det brede spekteret av menneskelig aktivitet og interesse som opptar borgere i det moderne samfunn.
            </p>
            
            <p className="text-foreground">
              Briefr er redaktørstyrt og driftes etter Vær Varsom-plakaten og Redaktørplakaten.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AboutPage;
